import React from 'react'

const LoadingIconSmall = () => (
  <div className="loading-icon-small">
    <div className="bounce1" />
    <div className="bounce2" />
    <div className="bounce3" />
  </div>
)

export default LoadingIconSmall



// WEBPACK FOOTER //
// ./src/Components/LoadingIconSmall.js